export const useTermsStore = defineStore("termsStore", () => {
	// The terms endpoint also needs aws_event_id but that can be pulled from the nuxtConfig
	const email = ref("")
	const signature = ref("")
	const signedAt = ref<Date | null>(null)

	const setEmail = (value = "") => {
		email.value = value
	}

	const setSignature = (value = "") => {
		signature.value = value
	}

	const setSignedAt = (value: Date | null) => {
		signedAt.value = value
	}

	const setTermsStore = (termsTore: any) => {
		email.value = termsTore.email
	}

	const clearSignature = () => {
		signature.value = ""
		signedAt.value = null
	}

	const $reset = () => {
		email.value = ""
		signature.value = ""
		signedAt.value = null
	}

	return {
		email,
		setEmail,
		signature,
		setSignature,
		signedAt,
		setSignedAt,
		setTermsStore,
		clearSignature,
		$reset,
	}
})
